import { gql } from "@apollo/client";

export const CREATE_ADICIONAL_RI = gql`
    mutation CreateAdicionalRI(
        $input: AddAdicionalInput!)
    {
        createAdicionalRI(
            input: $input
        ){
            idDatosGeneralesRI
        }
    }
`;